import { useState } from 'react';
import { apiDriverApp } from '../../../../../libs/apiDriverApp';
import { apiConnectcenter } from '../../../../../libs/apiConnectcenter';

export const useVendorManagementApi = () => {
   const [fetchingStats, setFetchingStats] = useState(false);
   const [fetchingVendors, setFetchingVendors] = useState(false);
   const [fetchingLiveryVendors, setFetchingLiveryVendors] = useState(false);
   const [updatingData, setUpdatingData] = useState(false);
   const [error, setError] = useState(null);

   const getVendorStats = async () => {
      setFetchingStats(true);
      setError(null);

      try {
         const { data } = await apiDriverApp.get(`api/vendors/vendors/stats/`);

         return data;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setFetchingStats(false);
      }
   };

   const getVendors = async ({ page = 1, pageSize = 10, search, active }) => {
      setFetchingVendors(true);
      setError(null);

      try {
         const { data } = await apiDriverApp.get(`api/vendors/vendors/`, {
            params: {
               page: page ? page : undefined,
               page_size: pageSize ? pageSize : undefined,
               search: search || undefined,
               active: active ? active : undefined,
            },
         });

         return data;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setFetchingVendors(false);
      }
   };

   const getLiveryVendors = async () => {
      setFetchingLiveryVendors(true);
      setError(null);

      try {
         const { data } = await apiConnectcenter.get('api/v1/vendors/');
         // Returns { success: true, count: N, vendors: [...] }
         return data.vendors || [];
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setFetchingLiveryVendors(false);
      }
   };

   const addVendor = async (vendorBody) => {
      setUpdatingData(true);
      setError(null);

      try {
         const response = await apiDriverApp.post(`api/vendors/vendors/`, vendorBody);

         return response;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setUpdatingData(false);
      }
   };

   const deleteVendor = async (vendorId) => {
      setUpdatingData(true);
      setError(null);

      try {
         const response = await apiDriverApp.delete(`api/vendors/vendors/${vendorId}/`);

         return response;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setUpdatingData(false);
      }
   };

   const updateVendor = async (vendorId, vendorBody) => {
      setUpdatingData(true);
      setError(null);

      try {
         const response = await apiDriverApp.put(`api/vendors/vendors/${vendorId}/`, vendorBody);

         return response;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setUpdatingData(false);
      }
   };

   return {
      fetchingStats,
      fetchingVendors,
      fetchingLiveryVendors,
      updatingData,
      error,
      getVendorStats,
      getVendors,
      getLiveryVendors,
      addVendor,
      deleteVendor,
      updateVendor,
   };
};
